const palette = ["#2563eb", "#7c3aed", "#059669", "#dc2626", "#d97706", "#0891b2"];

const hashStr = (s = "") => [...s].reduce((acc, c) => acc + c.charCodeAt(0), 0);

export const Avatar = ({ user, size = 34 }) => {
  const initials = user.name.split(" ").map(n => n[0]).slice(0, 2).join("").toUpperCase();
  const bg = palette[hashStr(user.id) % palette.length];
  if (user.photo)
    return <img src={user.photo} alt={user.name} style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />;
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", background: bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.36, fontWeight: 600, color: "#fff", flexShrink: 0 }}>
      {initials}
    </div>
  );
};
